<template>
  <div class="otn-step-one">
    <v-layout justify-center>
      <v-radio-group
        v-model="form.otn"
        row
      >
        <v-radio
          class="mr-8"
          label="OTN"
          value="OTN"
          hide-details
        />
        <v-radio
          class="mr-8"
          label="VLONDER"
          value="VLONDER"
          hide-details
        />
        <v-radio
          class="mr-8"
          label="IKEA"
          value="IKEA"
          hide-details
        />
        <v-radio
          label="AU SOL"
          value="ON_GROUND"
        />
      </v-radio-group>
    </v-layout>

    <hr>

    <v-layout
      justify-center
      mt-5
      mb-5
    >
      <v-text-field
        v-model="form.max_width"
        v-validate="'numeric|max:4'"
        data-vv-name="Largeur max"
        :class="{ error: errors.has('Largeur max') }"
        class="sm4 mr-5"
        label="Largeur max en mm"
        type="number"
        outlined
        hide-details
      />
      <v-text-field
        v-model="form.max_length"
        v-validate="'numeric|max:4'"
        data-vv-name="Longueur max"
        :class="{ error: errors.has('Longueur max') }"
        class="sm4"
        label="Longueur max en mm"
        type="number"
        outlined
        hide-details
      />
    </v-layout>

    <v-switch
      v-model="form.idc_cover"
      hide-details
      label="Housses en tissu coton (dans la limite de 4) :"
      class="title"
      @change="clearCoverFields"
    />

    <v-radio-group
      v-model="form.cover_in_part"
      hide-details
      row
      :disabled="!form.idc_cover"
    >
      <v-radio
        label="En 1 partie"
        value="1PART"
      />
      <v-radio
        label="En 2 parties"
        value="2PARTS"
      />
    </v-radio-group>

    <v-layout
      justify-end
      bt-12
    >
      <v-switch
        hide-details
        label="Prévisualisation"
        :disabled="!form.idc_cover"
      />
    </v-layout>

    <v-simple-table class="mb-12">
      <thead>
        <tr>
          <th class="text-center" />
          <th class="text-center">
            HOUSE 1
          </th>
          <th class="text-center">
            HOUSE 2
          </th>
          <th class="text-center">
            HOUSE 3
          </th>
          <th class="text-center">
            HOUSE 4
          </th>
          <th class="text-center">
            HS1
          </th>
          <th class="text-center">
            HS2
          </th>
          <th class="text-center">
            HS3
          </th>
          <th class="text-center">
            HS4
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>INTER</th>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.cover1_intern_id"
                :items="stretchColors"
                item-text="label"
                item-value="id"
                label
                filled
                hide-details
                clearable
                :disabled="!form.idc_cover"
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.cover2_intern_id"
                :items="stretchColors"
                item-text="label"
                item-value="id"
                label
                filled
                hide-details
                clearable
                :disabled="!form.idc_cover"
              />
            </v-layout>
          </td>
          <td>
            <v-select
              v-model="form.cover3_intern_id"
              :items="stretchColors"
              item-text="label"
              item-value="id"
              label
              filled
              hide-details
              clearable
              :disabled="!form.idc_cover"
            />
          </td>
          <td>
            <v-select
              v-model="form.cover4_intern_id"
              :items="stretchColors"
              item-text="label"
              item-value="id"
              label
              filled
              hide-details
              clearable
              :disabled="!form.idc_cover"
            />
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.hs1_intern_id"
                :items="stretchColors"
                item-text="label"
                item-value="id"
                label
                filled
                hide-details
                clearable
                :disabled="!form.idc_cover"
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.hs2_intern_id"
                :items="stretchColors"
                item-text="label"
                item-value="id"
                label
                filled
                hide-details
                clearable
                :disabled="!form.idc_cover"
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.hs3_intern_id"
                :items="stretchColors"
                item-text="label"
                item-value="id"
                label
                filled
                hide-details
                clearable
                :disabled="!form.idc_cover"
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.hs4_intern_id"
                :items="stretchColors"
                item-text="label"
                item-value="id"
                label
                filled
                hide-details
                clearable
                :disabled="!form.idc_cover"
              />
            </v-layout>
          </td>
        </tr>

        <tr>
          <th>EXTER</th>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.cover1_extern_id"
                :items="stretchColors"
                item-text="label"
                item-value="id"
                label
                filled
                hide-details
                clearable
                :disabled="!form.idc_cover"
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.cover2_extern_id"
                :items="stretchColors"
                item-text="label"
                item-value="id"
                label
                filled
                hide-details
                clearable
                :disabled="!form.idc_cover"
              />
            </v-layout>
          </td>
          <td>
            <v-select
              v-model="form.cover3_extern_id"
              :items="stretchColors"
              item-text="label"
              item-value="id"
              label
              filled
              hide-details
              clearable
              :disabled="!form.idc_cover"
            />
          </td>
          <td>
            <v-select
              v-model="form.cover4_extern_id"
              :items="stretchColors"
              item-text="label"
              item-value="id"
              label
              filled
              hide-details
              clearable
              :disabled="!form.idc_cover"
            />
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.hs1_extern_id"
                :items="stretchColors"
                item-text="label"
                item-value="id"
                label
                filled
                hide-details
                clearable
                :disabled="!form.idc_cover"
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.hs2_extern_id"
                :items="stretchColors"
                item-text="label"
                item-value="id"
                label
                filled
                hide-details
                clearable
                :disabled="!form.idc_cover"
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.hs3_extern_id"
                :items="stretchColors"
                item-text="label"
                item-value="id"
                label
                filled
                hide-details
                clearable
                :disabled="!form.idc_cover"
              />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select
                v-model="form.hs4_extern_id"
                :items="stretchColors"
                item-text="label"
                item-value="id"
                label
                filled
                hide-details
                clearable
                :disabled="!form.idc_cover"
              />
            </v-layout>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <HousseComplexe :form="form" />


    <v-switch
      v-model="form.breastplate_module.idc_breastplate"
      hide-details
      label="Plastron :"
      class="title"
      @change="clearBreastplateFields"
    />
    <v-layout v-if="form.breastplate_module">
      <v-flex sm4>
        <v-radio-group
          v-model="form.breastplate_module.breastplate_type"
          hide-details
          :disabled="!form.breastplate_module.idc_breastplate"
        >
          <v-layout
            class="checkbox-input-container mb-4"
            align-center
          >
            <v-flex sm6>
              <v-radio
                label="Plastron"
                value="BREASTPLATE"
              />
            </v-flex>
            <v-flex
              sm6
              class="checkbox-input visible"
            >
              <v-select
                v-model="form.breastplate_module.breastplate"
                :items="breastPlateModule.breastplate"
                item-text="label"
                item-value="value"
                label="Thorax"
                filled
                hide-details
                :disabled="!form.breastplate_module.idc_breastplate"
              />
            </v-flex>
          </v-layout>
          <v-layout
            class="checkbox-input-container"
            align-center
          >
            <v-flex sm6>
              <v-radio
                label="Boléro"
                value="BOLERO"
              />
            </v-flex>
            <v-flex
              sm6
              class="checkbox-input visible"
            >
              <v-select
                v-model="form.breastplate_module.size"
                :items="breastPlateModule.size"
                item-text="label"
                item-value="value"
                filled
                hide-details
                :disabled="!form.breastplate_module.idc_breastplate"
              />
            </v-flex>
          </v-layout>
        </v-radio-group>
      </v-flex>
      <v-flex sm5>
        <div class="content">
          <div class="img-container">
            <img src="@/assets/img/schema_otn_1a.svg">
            <v-text-field
              v-model="form.breastplate_module.a"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Schéma A"
              :class="{ error: errors.has('(Plastron) Schéma A') }"
              outlined
              type="number"
              style="top: 20.1%;left: 32.8%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
            />
            <v-text-field
              v-model="form.breastplate_module.a"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Schéma A"
              :class="{ error: errors.has('(Plastron) Schéma A') }"
              outlined
              type="number"
              style="top: 20.1%;left: 80.4%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
            />
            <v-text-field
              v-model="form.breastplate_module.b"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Schéma B"
              :class="{ error: errors.has('(Plastron) Schéma B') }"
              outlined
              type="number"
              style="top: 3%;left: 56.9%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
            />
            <v-text-field
              v-model="form.breastplate_module.c"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Schéma C"
              :class="{ error: errors.has('(Plastron) Schéma C') }"
              outlined
              type="number"
              style="top: 44.3%;left: 72.3%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
            />
            <v-text-field
              v-model="form.breastplate_module.d"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Schéma D"
              :class="{ error: errors.has('(Plastron) Schéma D') }"
              outlined
              type="number"
              style="top: 84.9%;left: 56.3%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
            />
            <v-text-field
              v-model="form.breastplate_module.e"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Schéma E"
              :class="{ error: errors.has('(Plastron) Schéma E') }"
              outlined
              type="number"
              style="top: 53.3%;left: 0.2%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
            />
          </div>
        </div>
      </v-flex>
      <v-flex sm3>
        <v-radio-group
          v-model="form.breastplate_module.construction_type"
          hide-details
          :disabled="!form.breastplate_module.idc_breastplate"
        >
          <v-radio
            label="Gabarit"
            value="TEMPLATE"
          />
          <v-radio
            label="Sur mesures"
            value="CUSTOM_MADE"
          />
        </v-radio-group>
        <v-switch
          v-model="form.breastplate_module.idc_shoulder_socket"
          label="Réhausse épaule"
          hide-details
          :disabled="!form.breastplate_module.idc_breastplate"
        />
        <v-switch
          v-model="form.breastplate_module.idc_adjustment_cebelor"
          label="Réglage Cebelor"
          hide-details
          class="mt-0"
          :disabled="!form.breastplate_module.idc_breastplate"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HousseComplexe from "../../modules/HousseComplexe.vue";


export default {
  name: "OtnStepOne",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  components: {
    HousseComplexe
  },
  computed: {
    ...mapGetters({
      stretchColors: "colors/getSTRETCHType",

      breastPlateModule: "dropdowns/getBreastPlateOptions"
    })
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear cover fields
    clearCoverFields() {
      this.form.cover_in_part = null;
      this.form.cover1_intern_id = null;
      this.form.cover2_intern_id = null;
      this.form.cover3_intern_id = null;
      this.form.cover4_intern_id = null;
      this.form.hs1_intern_id = null;
      this.form.hs2_intern_id = null;
      this.form.hs3_intern_id = null;
      this.form.hs4_intern_id = null;
      this.form.cover1_extern_id = null;
      this.form.cover2_extern_id = null;
      this.form.cover3_extern_id = null;
      this.form.cover4_extern_id = null;
      this.form.hs1_extern_id = null;
      this.form.hs2_extern_id = null;
      this.form.hs3_extern_id = null;
      this.form.hs4_extern_id = null;
    },

    // Clear breastplate fields
    clearBreastplateFields() {
      this.form.breastplate_module.breastplate = null;
      this.form.breastplate_module.breastplate_type = null;
      this.form.breastplate_module.size = null;
      this.form.breastplate_module.a = null;
      this.form.breastplate_module.b = null;
      this.form.breastplate_module.c = null;
      this.form.breastplate_module.d = null;
      this.form.breastplate_module.e = null;
      this.form.breastplate_module.construction_type = null;
      this.form.breastplate_module.idc_shoulder_socket = false;
      this.form.breastplate_module.idc_adjustment_cebelor = false;
    }
  }
};
</script>

<style lang="scss">
.otn-step-one {
  .content {
    display: flex;
    //min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        //height: 100%;
        //width: 100%;
        //min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 16.7%;
        height: 12.4%;
        @media (max-width: 800px) {
          height: 12.4%;
        }
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }
  .v-data-table {
    table {
      thead {
        tr {
          th {
            font-size: 11px !important;
          }
        }
      }
    }
  }

  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: none !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
}
</style>
